/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";

export function hasChanges(state: ApplicationState) {
    const {
        userSetup: { userId, editingUser },
    } = state.pages;

    const user = getAccountState(state, userId).value;
    
    if (!user || !editingUser) {
        return false;
    }

    const { budgetManagementEnabled, rolesThatRequireApprover } = getSettingsCollection(state).customSettings as any;
    const isTheSelectedUserRequireApprover = budgetManagementEnabled && rolesThatRequireApprover.includes(editingUser.role);
    const hasApproverChanged =  isTheSelectedUserRequireApprover ? user.approver !== editingUser.approver : false;

    return (
        user.email !== editingUser.email ||
            user.firstName !== editingUser.firstName ||
            user.lastName !== editingUser.lastName ||
            user.role !== editingUser.role ||
            hasApproverChanged ||
        user.isApproved !== editingUser.isApproved
    );
}

export const getCurrentEditingUser = (state: ApplicationState) => state.pages.userSetup.editingUser;
